export const data3 = [
    {
        title:"Mail Chimp & Co",
        desc:"Join our community for freelancers and agencies to unlock tools for managing clients and perks to grow your business."
    },
    {
        title:"Features For Helping Clients",
        desc:"Helping small businesses with their marketing just got simpler. Join Mailchimp & Co and get access to unique features that help you do more for your clients."
    }
    ,{
        title:"Unlock the perks of Mailchimp & Co",
        desc:"Tools, support and rewards designed to help freelancers and agencies—like you—grow."
    },
    {
        title:"Learn in good company",
        desc:"Get expert advice from your fellow freelancers and agencies, pick up some new tricks, and explore upcoming events."
    }
]